import { render } from "./KPISetDeleteModal.vue?vue&type=template&id=66c386de"
import script from "./KPISetDeleteModal.vue?vue&type=script&lang=js"
export * from "./KPISetDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__